'use strict';

var hover = require('../../gestures/hover.cjs');
var focus = require('../../gestures/focus.cjs');
var press = require('../../gestures/press.cjs');
var index = require('./viewport/index.cjs');

const gestureAnimations = {
    inView: {
        Feature: index.InViewFeature,
    },
    tap: {
        Feature: press.PressGesture,
    },
    focus: {
        Feature: focus.FocusGesture,
    },
    hover: {
        Feature: hover.HoverGesture,
    },
};

exports.gestureAnimations = gestureAnimations;
//# sourceMappingURL=gestures.cjs.map
